import merge from 'ts-deepmerge';

import baseTheme from './baseTheme';
import type { BaseTheme, BrandTheme, Theme } from './types';

const createTheme = <T extends BrandTheme>(theme: T) => {
  const arr: (BrandTheme | BrandTheme | BaseTheme | Theme)[] = [
    baseTheme,
    theme,
  ];
  return merge.withOptions({ mergeArrays: false }, ...arr) as T & BaseTheme;
};

export default createTheme;
